import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor;

//

$w.onReady(function () {
    setButtons()
});

function setButtons() {
    if (formFactor === "Mobile") {
        $w("#buttonFold1").label = "Discover More"
        $w("#buttonFold1").onClick((event) => {
            $w("#fold2").scrollTo()
        });

        $w("#buttonFold2").label = "Read More"
        $w("#buttonFold2").link = "https://support.wix.com/en/pos-solutions/mobile-pos-for-wix-events"

        $w("#buttonFold3").label = "Tell Me More"
        $w("#buttonFold3").onClick((event) => {
            $w("#columnStripFAQ").scrollTo()
        });

        $w("#buttonFold4").label = "Tell Me More"
        $w("#buttonFold4").onClick((event) => {
            $w("#columnStripFAQ").scrollTo()
        });

    } else {
        $w("#buttonFold1").link = "https://www.wix.com/my-account/site-selector/?title=Set%20up%20Wix%20Payments&buttonText=Connect%20Now&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fpayments%2F?referralInfo=events_pos"

        $w("#buttonFold2").link = "https://www.wix.com/my-account/site-selector/?title=Set%20up%20Wix%20Payments&buttonText=Connect%20Now&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fpayments%2F?referralInfo=events_pos"

        $w("#buttonFold3").link = "https://www.wix.com/my-account/site-selector/?title=Set%20up%20Wix%20Payments&buttonText=Connect%20Now&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fpayments%2F?referralInfo=events_pos"

        $w("#buttonFold4").link = "https://www.wix.com/my-account/site-selector/?title=Set%20up%20Wix%20Payments&buttonText=Connect%20Now&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fpayments%2F?referralInfo=events_pos"
    }
}